;(function(){
	var formControlList;
	var TABLET_RESOLUTION = 1281;

	formControlList = Array.prototype.slice.call(
		document.getElementsByClassName('form-control')
	);
	formControlList.forEach(function(item) {
		item.addEventListener('focus', function(e) {
			if (document.documentElement.clientWidth < TABLET_RESOLUTION) {
				var scrollable = $(e.target).closest('.fp-scrollable');
				var iScrollInstance = scrollable.data('iscrollInstance');
				setTimeout(function(){
					if (iScrollInstance) {
						iScrollInstance.scrollToElement(e.target,1000,0,0,{
							style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
							fn: function (k) {
								return k * ( 2 - k );
							}
						});
					} else {
						e.target.scrollIntoView(false);
					}
				},900)
			}
		})
	})

})();



//////////////////
// WEBPACK FOOTER
// ./frontend/js/form-control-helper.js
// module id = 4
// module chunks = 0